import { useEffect, useState } from "react";

type WindowSize = "mobile" | "tab" | "laptop" | null;

const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>(null);

  useEffect(() => {
    const windowSizeHandler = (): void => {
      if (window.innerWidth <= 599) {
        setWindowSize("mobile");
      } else if (window.innerWidth >= 600 && window.innerWidth <= 799) {
        setWindowSize("tab");
      } else if (window.innerWidth >= 800) {
        setWindowSize("laptop");
      }
    };

    windowSizeHandler(); // Set initial value
    window.addEventListener("resize", windowSizeHandler);

    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  return windowSize;
};

export default useWindowSize;

